import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { PreviousSectionId, Section } from './section';
export var Sections = /*#__PURE__*/function () {
  function Sections() {
    _classCallCheck(this, Sections);
  }

  _createClass(Sections, null, [{
    key: "sortSections",
    value: function sortSections(sections) {
      var sortedSections = [];
      var headSection = sections.find(function (section) {
        return section.previousSectionId.toString() === PreviousSectionId.None;
      });
      sortedSections.push(headSection);
      var currentSectionId = headSection.id.toString();
      sections.forEach(function () {
        var nextSection = sections.find(function (section) {
          return section.previousSectionId.toString() === currentSectionId;
        });

        if (!nextSection) {
          return;
        }

        sortedSections.push(nextSection);
        currentSectionId = nextSection === null || nextSection === void 0 ? void 0 : nextSection.id.toString();
      });
      return sortedSections;
    }
  }, {
    key: "updateSections",
    value: function updateSections(sections, changedSection) {
      var result = sections.map(function (section) {
        if (section.id.toString() === changedSection.id.toString()) {
          return changedSection;
        }

        return section;
      });
      return result;
    }
  }, {
    key: "cloneTo",
    value: function cloneTo(sections) {
      var clonedSections = sections.map(function (s) {
        return Section.cloneTo(s);
      });
      return clonedSections;
    }
  }, {
    key: "insertSectionToSections",
    value: function insertSectionToSections(input) {
      var addedSection = input.addedSection,
          sections = input.sections;

      if (!sections || !sections.length) {
        return [addedSection];
      }

      var newSection = Section.cloneTo(addedSection);
      var isExistedNewSection = sections.find(function (s) {
        return s.id.toString() === newSection.id.toString();
      });
      if (isExistedNewSection) return;
      var updatedSections = [].concat(_toConsumableArray(sections), [newSection]);
      var nextSection;

      if (newSection.previousSectionId === 'none') {
        nextSection = sections.find(function (s) {
          return s.previousSectionId === 'none';
        });
      } else {
        nextSection = sections.find(function (s) {
          return s.previousSectionId === newSection.previousSectionId;
        });
      }

      if (!nextSection) {
        return updatedSections;
      }

      nextSection.updatePreviousSectionId(newSection.id.toString());
      var result = Sections.sortSections(updatedSections);
      return result;
    }
  }, {
    key: "deleteSection",
    value: function deleteSection(sectionId, sections) {
      var deletedIndex = sections.findIndex(function (section) {
        return section.id.toString() === sectionId;
      });
      var deletedSection = sections[deletedIndex];
      var nextSection = sections[deletedIndex + 1];
      nextSection === null || nextSection === void 0 ? void 0 : nextSection.updatePreviousSectionId(deletedSection.previousSectionId);
      var sectionsUpdate = sections.filter(function (section) {
        return section.id.toString() !== sectionId;
      });
      return sectionsUpdate;
    }
  }]);

  return Sections;
}();